import styled from 'styled-components';
import BaseLocationMarker from '#/shared/components/GeneratedIcons/trimet/SelectedLocationMarker';
import featureFlags from '#/shared/feature-flags';

const { mapLibre } = featureFlags;

export const SelectedLocationIcon = styled(BaseLocationMarker).attrs({
  width: 50,
  height: 50,
})`
  ${mapLibre ? '' : 'transform: translate(-50%, -100%);'}
  &:hover {
    cursor: pointer;
  }
`;

export default SelectedLocationIcon;
